import React from 'react';

export default function ConversionFlowVehicle({ summary, summaryMinimal }) {
    const { vehicle } = summary || {};
    const specs = [
        {
            key: 'fuel_type',
            value: vehicle?.brandstof,
        },
        {
            key: 'construction_year',
            value: vehicle?.bouwjaar,
        },
        {
            key: 'mileage',
            value: `${vehicle?.tellerstand?.toLocaleString('nl-NL')} km`,
        }

    ]

    return (
        <div className="row">
            <div className="col-12">
                <p className="text--16 mb-0 font-weight-bold">
                    {vehicle?.brand} {vehicle?.model}
                </p>
                <p className="text--sm text-muted--60">
                    {vehicle?.type}
                </p>

            </div>
            {!summaryMinimal && (
                <div className="col-12">
                    <div className="row gutters-2">
                        {specs?.map((spec) => (
                            <div key={spec?.key} className="col-auto">
                                <div className="d-flex flex-column flex-xxl-row align-items-xxl-center">
                                    <p className="text--sm text-muted--60">
                                        {spec?.value}
                                    </p>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            )}
        </div>
    )
}
